import initFormViewer from '../utils/init-form-viewer'

const viewerEls = document.querySelectorAll('.bhub-form-viewer')
if (viewerEls) {
  ;[...viewerEls].map((viewerEl) => {
    initFormViewer(viewerEl)
  })
}
